var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "flex" },
      _vm._l(_vm.$AllProjects, function (project) {
        return project.is_active && ![13].includes(project.id)
          ? _c("div", { staticClass: "project" }, [
              _c("div", { staticClass: "text-center" }, [
                _c(
                  "strong",
                  [
                    _vm._v(_vm._s(project.title) + "\n        "),
                    project.id === 1 ? [_vm._v("(+ФДЛ)")] : _vm._e(),
                    _vm._v(" "),
                    project.id === 12 ? [_vm._v("(+ФДК(Р))")] : _vm._e(),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _vm.projectPrices[project.id]
                ? _c(
                    "div",
                    _vm._l(_vm.projectPrices[project.id], function (p) {
                      return _c("p", [
                        _vm._v("\n          " + _vm._s(p.qty) + ": "),
                        _c("strong", [_vm._v(_vm._s(p.price))]),
                      ])
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.createTasks[project.id]
                ? _c(
                    "div",
                    { staticClass: "text-center" },
                    [
                      _vm.loading[project.id]
                        ? [
                            _c("clip-loader", {
                              attrs: {
                                loading: true,
                                color: _vm.$constants.LOADING_COLOR,
                                size: "20px",
                              },
                            }),
                          ]
                        : [
                            _c("i", { staticClass: "icon-fa icon-fa-clock-o" }),
                            _vm._v(" "),
                            _c("i", {
                              staticClass:
                                "pointer hover_red icon-fa icon-fa-remove",
                              on: {
                                click: function ($event) {
                                  return _vm.addTask(project.id, true)
                                },
                              },
                            }),
                          ],
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.projectPrices[project.id] && !_vm.createTasks[project.id]
                ? _c(
                    "div",
                    { staticClass: "text-center" },
                    [
                      _vm.loading[project.id]
                        ? [
                            _c("clip-loader", {
                              attrs: {
                                loading: true,
                                color: _vm.$constants.LOADING_COLOR,
                                size: "20px",
                              },
                            }),
                          ]
                        : [
                            _c("i", {
                              staticClass: "icon-fa icon-fa-plus-square green",
                              on: {
                                click: function ($event) {
                                  return _vm.addTask(project.id)
                                },
                              },
                            }),
                          ],
                    ],
                    2
                  )
                : _vm._e(),
            ])
          : _vm._e()
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }